/**
 * @generated SignedSource<<5b8f06337d1f19909642532294d077cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FundsserviceAutocomplete_autocomplete$data = {
  readonly furtherResultsMessage: string | null | undefined;
  readonly items: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly country: string | null | undefined;
        readonly fundsname: string | null | undefined;
        readonly largeinvestmentfonds: number | null | undefined;
        readonly tranches: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly isin: string | null | undefined;
              readonly salesadmission: ReadonlyArray<string | null | undefined> | null | undefined;
              readonly url: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly noResultsMessage: string | null | undefined;
  readonly " $fragmentType": "FundsserviceAutocomplete_autocomplete";
};
export type FundsserviceAutocomplete_autocomplete$key = {
  readonly " $data"?: FundsserviceAutocomplete_autocomplete$data;
  readonly " $fragmentSpreads": FragmentRefs<"FundsserviceAutocomplete_autocomplete">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FundsserviceAutocomplete_autocomplete",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noResultsMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "furtherResultsMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "FundsConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FundsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Funds",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fundsname",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "country",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "largeinvestmentfonds",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": (v0/*: any*/),
                  "concreteType": "TrancheConnection",
                  "kind": "LinkedField",
                  "name": "tranches",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TrancheEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Tranche",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "url",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isin",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "salesadmission",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "tranches(first:1000)"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "items(first:1000)"
    }
  ],
  "type": "HomeFundServiceAutocomplete",
  "abstractKey": null
};
})();

(node as any).hash = "11ef20e74142634610206b6e7beaa5ce";

export default node;
